import { ConfirmModal } from '@sparklayer-io/spark-dash-ui/components/confirm-modal';
import { t } from 'i18next';
import { useHandlers } from '../../../../../context/page-context';
import type { TeamInviteApiResponse } from '../../../types';
import { useDeleteTeamInvite } from '../../hooks/use-delete-team-invite';

export function DeleteInviteModal({
  invite,
  isOpen,
  closeModal,
}: {
  invite: TeamInviteApiResponse | null;
  isOpen: boolean;
  closeModal: () => void;
}) {
  const { notificationHandler } = useHandlers();
  const { mutate: deleteInvite, isPending, reset } = useDeleteTeamInvite();

  const handleClose = () => {
    reset();
    closeModal();
  };

  const handleSubmit = () => {
    if (!invite) {
      return;
    }

    deleteInvite(invite.id, {
      onSuccess: handleClose,
      onError: () => notificationHandler.error(),
    });
  };

  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={handleClose}
      onConfirm={handleSubmit}
      loading={isPending}
      title={t('features:account.components.modals.delete_invite_modal.header')}
      confirmText={t('buttons:delete')}
      message={t('features:account.components.modals.delete_invite_modal.body', {
        email: invite?.email ?? '',
      })}
    />
  );
}
